module.exports = __webpack_public_path__ + "img/eyes_male_asian_thin.5585b890.png";